<div class="flex w-full">
  <label nz-checkbox [formControl]="formControl" >{{ interfaceName }}</label>
</div>
<pre>{{ model | json}}</pre>
